import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=b073ced0&scoped=true&"
import script from "./BillList.vue?vue&type=script&lang=js&"
export * from "./BillList.vue?vue&type=script&lang=js&"
import style0 from "./BillList.vue?vue&type=style&index=0&id=b073ced0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b073ced0",
  null
  
)

export default component.exports